// Lib
import React from 'react';
import PropTypes from 'prop-types';
import { compose } from '../../../node_module_clones/recompose';
import { connect } from 'react-redux';
import measurementsConnect from '../../components/measurementsStore/measurementsConnect';

// Utils
import { bindShortcuts } from './keyboardShortcuts';
import rIC from '../../../common/utils/lib/rIC';

// Components
import LoadableShortcutsModal from './modal/LoadableShortcutsModal';
import editorStoreConnect from '../../components/editor/store/components/editorStoreConnect';
import { Capacitor } from '@capacitor/core';
import { CAPACITOR_KEYBOARD_SHORTCUT_NAME } from '../../../capacitor_plugins/pluginConstants';
import useAttachKeyboardShortcuts from '../../capacitor/hooks/useAttachKeyboardShortcuts';

const mapMeasurementsDispatchToProps = (measurementsDispatch) => ({
    measurementsDispatch,
});

const mapEditorDispatchToProps = (editorDispatch) => ({
    editorDispatch,
});

const enhance = compose(
    measurementsConnect(null, mapMeasurementsDispatchToProps),
    editorStoreConnect(null, mapEditorDispatchToProps),
    connect(),
);

// Props will have { dispatch, measurementsDispatch }
const WorkspaceKeyboardShortcutHandler = (props) => {
    // The return of bindShortcuts is the unbind, which will be executed on unmount
    React.useEffect(() => {
        const unbind = bindShortcuts(props);

        // Preload the Shortcuts modal to improve the opening animation the first time it's opened
        setTimeout(() => {
            rIC(() => {
                LoadableShortcutsModal.preload();
            });
        }, 5000);

        return unbind;
    }, []);

    if (Capacitor.isPluginAvailable(CAPACITOR_KEYBOARD_SHORTCUT_NAME)) {
        useAttachKeyboardShortcuts(props.editorDispatch);
    }

    return null;
};

WorkspaceKeyboardShortcutHandler.propTypes = {
    dispatch: PropTypes.func,
    measurementsDispatch: PropTypes.func,
    editorDispatch: PropTypes.func,
};

export default enhance(WorkspaceKeyboardShortcutHandler);
